import { render, staticRenderFns } from "./CampaignPointsOfSaleSelection.vue?vue&type=template&id=9fc10f14&"
import script from "./CampaignPointsOfSaleSelection.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsOfSaleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports